import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onMouseenter", "onMouseleave"]
const _hoisted_2 = { class: "echarts-circular__legend-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EChartsCore = _resolveComponent("EChartsCore")!
  const _component_EChartsBase = _resolveComponent("EChartsBase")!

  return (_openBlock(), _createBlock(_component_EChartsBase, {
    isEmpty: _ctx.getIsEmpty,
    titleConfig: _ctx.titleConfig
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["echarts-circular", `echarts-circular--legend-${_ctx.legendPosition}`])
      }, [
        _createElementVNode("div", {
          class: "echarts-circular__chart",
          style: _normalizeStyle({ height: `${_ctx.getBaseChartHeight}px`, width: `${_ctx.width}px` })
        }, [
          _createVNode(_component_EChartsCore, {
            ref: "echartsCore",
            option: _ctx.getChartOption,
            autoresize: "",
            loading: _ctx.isLoading,
            loadingOptions: _ctx.getLoadingOptions
          }, null, 8, ["option", "loading", "loadingOptions"])
        ], 4),
        (_ctx.isShowLegend && _ctx.getLegendItems.length > 0)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 0,
              class: _normalizeClass(["echarts-circular__legend", _ctx.legendClass]),
              style: _normalizeStyle(_ctx.getLegendGridStyle)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getLegendItems, (legendItem, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: legendItem.name,
                  class: "echarts-circular__legend-item",
                  onMouseenter: ($event: any) => (_ctx.onLegendItemMouseEnter(index)),
                  onMouseleave: ($event: any) => (_ctx.onLegendItemMouseLeave(index))
                }, [
                  _createElementVNode("span", {
                    class: "echarts-circular__legend-marker",
                    style: _normalizeStyle({ backgroundColor: legendItem.color })
                  }, null, 4),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(legendItem.name), 1)
                ], 40, _hoisted_1))
              }), 128))
            ], 6))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }, 8, ["isEmpty", "titleConfig"]))
}